import { styled } from '@mui/material';

export const PatientInfoWrapper = styled('div')({
  padding: '0 20px 20px 0px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: 'black'
});

export const PatientName = styled('div')({
  display: 'flex',
  fontSize: '22px',
  fontWeight: 500,
  cursor: 'default',
  '& .communication-status': {
    alignSelf: 'flex-start',
    marginTop: 7,
    marginLeft: 10
  }
});

export const Filters = styled('div')({
  marginRight: 'auto',
  '& .communications-filters-header': {
    justifyContent: 'flex-end'
  },
  '& .MuiIconButton-root': {
    backgroundColor: 'transparent',
    color: '#000'
  }
});

export const PatientInfo = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '6px'
});

export const PatientDetails = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  letterSpacing: '0.15px',
  alignItems: 'center',
  marginTop: '4px'
});

export const RpWrapper = styled('span')({
  borderRadius: 4,
  marginRight: 8,
  border: '1px solid #000',
  padding: '2px 3px',
  fontSize: '10px',
});

